import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FetchAdminRolesService } from "./fetch-admin-roles.service";
import { AdminCreatorService } from "./admin-creator.service";
import { GetAdminService } from "./get-admin-service";
import { UpdateAdminRoleService } from "./update-admin-role.service";
import { GetRoleDetailsService } from '../../get-role-permissions.service';
import { Validators } from '../../../../../shared/validators';
import { FormValidatorService } from '../../../../../shared/services/form-validator.service';
import { CustomValidators } from '../../../../../shared/custom-validators';
import { MatSnackBar } from "@angular/material/snack-bar";
import { MerchantListService } from "../../../report/services/gate-services/merchant-list.service";
import { ReCaptchaService } from "angular-recaptcha3";

@Component({
  selector: 'app-create-admin',
  templateUrl: './create-admin.component.html',
  styleUrls: ['./create-admin.component.scss']
})
export class CreateAdminComponent implements OnInit {
  createAdminForm!: FormGroup;
  success = false;
  editMode = false;
  id: any;
  roles: { id: number; name: string }[] = [];
  merchants:{id:number,name:string}[]=[];
  selectedRole: any;
  rolePermissions: any;
  onlyNumberPattern = /^[0-9]*$/g;
  constructor(
    private rolesFetch: FetchAdminRolesService,
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private adminCreator: AdminCreatorService,
    private activatedRoute: ActivatedRoute,
    private getAdminService: GetAdminService,
    private router: Router,
    private updateAdminRoleService: UpdateAdminRoleService,
    private getRoleDetailsService: GetRoleDetailsService,
    private snackBar: MatSnackBar,
    private merchantListService: MerchantListService,
    private recaptchaService: ReCaptchaService,
  ) { }

  async ngOnInit() {
    await this.activatedRoute.params.subscribe(async a => {
      if (a["id"]) {
        this.editMode = true;
        this.id = a["id"];
        this.getAdminService.setParams({ id: this.id });
        const response = await this.getAdminService.make();
        console.log(response);
        await this.initForm();

        this.createAdminForm.controls["first_name"].setValue(
          response.first_name
        );
        this.createAdminForm.controls["last_name"].setValue(response.last_name);

        this.createAdminForm.controls["email"].setValue(response.email);
        // clear validator in edit mode because hashed password make error
        this.createAdminForm.controls["password"].clearValidators();
        this.createAdminForm.controls["password"].setValue(response.password);

        this.createAdminForm.controls["RoleId"].setValue(response.RoleId);
        this.createAdminForm.controls["merchantId"].setValue(response.merchantId || null);
        this.createAdminForm.controls["phone"].setValue(response.phone || null);
      } else {
        this.initForm();
      }
    });
  }

  async initForm() {
    this.createAdminForm = this.formValidator.createForm([
      {
        fieldName: "first_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "First name"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/^[a-zA-Z]*$/),
            message: this.translate.instant("FORMS.VALIDATION.TEXT_ONLY", {
              field: "first name"
            })
          },
          {
            validatorFn: Validators.minLength(2),
            message: this.translate.instant("FORMS.VALIDATION.MINIMUM_LENGTH", {
              field: "First name",
              value: 2
            })
          }
        ]
      },
      {
        fieldName: "last_name",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Last name"
            })
          },
          {
            validatorFn: CustomValidators.customPattern(/^[a-zA-Z]*$/),
            message: this.translate.instant("FORMS.VALIDATION.TEXT_ONLY", {
              field: "Last name"
            })
          },
          {
            validatorFn: Validators.minLength(2),
            message: this.translate.instant("FORMS.VALIDATION.MINIMUM_LENGTH", {
              field: "Last name",
              value: 2
            })
          }
        ]
      },
      {
        fieldName: "email",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Email"
            })
          },
          {
            validatorFn: Validators.email,
            message: this.translate.instant("FORMS.VALIDATION.FORMAT", {
              field: "Email"
            })
          }
        ]
      },
     {
        fieldName: "phone",
        defaultValue: null,
        validators: [
          {
            validatorFn: CustomValidators.requiredNumber,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Phone"
            })
          },
          {
            validatorFn: Validators.minLength(11),

            message: this.translate.instant("FORMS.VALIDATION.MINIMUM_LENGTH", {
              field: "Phone",
              value: 11
            })
          },
          {
            validatorFn: Validators.maxLength(11),
            message: this.translate.instant("FORMS.VALIDATION.MAXIMUM_LENGTH", {
              field: "Phone",
              value: 11
            })
          },
          {
            validatorFn: CustomValidators.customPattern(this.onlyNumberPattern),
            message: this.translate.instant('FormValidation.numbersOnly')
          },
        ]
      },
      {
        fieldName: "password",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Password"
            }),

          },
          {
            validatorFn: Validators.minLength(8),
            message: "Password can not be less than 8 characters",
          },
          {
            validatorFn: CustomValidators.complexPassword('s'),
            message: "Password Must Contain small characters,uppercase characters,special case characters and not include whitespaces",
          },
        ]
      },
      {
        fieldName: "RoleId",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Role"
            })
          }
        ]
      },
      {
        fieldName: "merchantId",
        defaultValue: null,
      }
    ]);

    try {
      const res: any[] = await this.rolesFetch.make();
      this.roles = res;
      const response =await this.merchantListService.make();
      this.merchants=response.merchants;
      // console.log(ordered);
    } catch (err) {
      console.log(err);
    }
  }

  async onSubmit() {
    try {
      if (this.editMode) {
        this.editMode = false;
        const recaptchaToken = await this.recaptchaService.execute({
          action: 'editAdmin',
        });
        this.updateAdminRoleService.setParams({
          id: this.id,
          RoleId: this.createAdminForm.value.RoleId,
          merchantId:this.createAdminForm.value.merchantId,
          recaptchaToken,
        });
        const res = await this.updateAdminRoleService.make();
        if (res.status === "success") {
          this.success = true;
          this.snackBar.open(`Admin Role Added Successfully!`, '', {
            duration: 3000
          });
        }
        console.log(res);
      } else {
        const recaptchaToken = await this.recaptchaService.execute({
          action: 'addAdmin',
        });
        this.adminCreator.setParams({
          ...this.createAdminForm.value,
          recaptchaToken,
        });
        const res = await this.adminCreator.make();
        if (res.status === "success") {
          this.success = true;
          this.snackBar.open(`Admin Role Edited Successfully!`, '', {
            duration: 3000
          });
        }
      }

      this.router.navigate(["/admin/actions/mangement"]);
    } catch (err) {
      if (err.validationErrors) {
        const e = err.validationErrors.error;
        for (const error of e) {
          this.formValidator.addError(error.field, "invalid", error.message);
          this.createAdminForm.controls[error.field].setErrors({
            invalid: error.message
          });
          this.formValidator.ShowErrors();
        }
      }
    }
  }

  async onRoleChange(newValue: any) {
    this.getRoleDetailsService.setParams({ id: newValue });
    const response = await this.getRoleDetailsService.make();
    this.rolePermissions = response.Permissions;
    console.log(response);
    return response;
  }

}
